import { BASE_URL } from "@/constants/endpoints";
import { TechnicianDetail } from "@/pages/config/technicians/schema/technicians.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let TechniciansApiPromise: Promise<AxiosInstance> | null = null;

const getTechniciansApi = async (): Promise<AxiosInstance | null> => {
  if (TechniciansApiPromise !== null) return TechniciansApiPromise;
  TechniciansApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return TechniciansApiPromise;
};

export interface GetTechniciansListProps {
  nombreApellido?: string;
  activo?: boolean;
  "P.Pagina": number;
  "P.Records"?: number;
}

export const getTechniciansList = async (props: GetTechniciansListProps) => {
  const api = await getTechniciansApi();
  if (!api) return;

  const response = await api.get(
    `/Tecnicos/All?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export const getActiveTechniciansList = async () => {
  const api = await getTechniciansApi();
  if (!api) return;

  const response = await api.get("/Tecnicos");

  return response.data;
};

export interface GetTechnicianProps {
  id: number;
}

export const getTechnician = async (
  props: GetTechnicianProps,
): Promise<TechnicianDetail | null> => {
  const api = await getTechniciansApi();
  if (!api) return null;

  const response = await api.get(`/Tecnicos/${props.id}`);

  return response.data;
};

export interface DeleteTechniciansProps {
  Ids: number[];
}

export const deleteTechnicians = async (props: DeleteTechniciansProps) => {
  const api = await getTechniciansApi();
  if (!api) return;

  const response = await api.delete(
    `/Tecnicos?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface CreateTechnicianProps {
  usuario: string;
  nombreApellido: string;
  email: string;
}

export const createTechnician = async (props: CreateTechnicianProps) => {
  const api = await getTechniciansApi();
  if (!api) return;

  const response = await api.post(`/Tecnicos`, props);

  return response.data;
};

export interface UpdateTechnicianProps {
  id: number;
  activo: boolean;
}

export const updateTechnician = async (props: UpdateTechnicianProps) => {
  const api = await getTechniciansApi();
  if (!api) return;

  const response = await api.patch(`/Tecnicos`, props);

  return response.data;
};
